import queryString from 'query-string';
import conf from '../config';
import { getOrganization } from './users';

const initialState = {
  materials: {},
  searchedMaterials: {},
  perPage: 24,
};

const ADD_MATERIAL = 'ADD_MATERIAL';
const SET_MATERIALS = 'SET_MATERIALS';
const SET_MATERIAL_REVIEW = 'SET_MATERIAL_REVIEW';
const DELETE_MATERIAL = 'DELETE_MATERIAL';
const SET_SEARCH_MATERIALS = 'SET_SEARCH_MATERIALS';
const UPDATE_SEARCH_MATERIAL = 'UPDATE_SEARCH_MATERIAL';
const DELETE_SEARCH_MATERIAL = 'DELETE_SEARCH_MATERIAL';
const CLEAR_DATA = 'CLEAR_DATA';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MATERIALS:
      const newMaterials = Object.assign({}, state.materials, action.payload);
      return { ...state, materials: newMaterials };
    case ADD_MATERIAL:
      const materials = state.materials;
      materials[action.payload._id] = action.payload;
      return { ...state, materials };
    case SET_MATERIAL_REVIEW:
      const mtl = state.materials[action.payload._id];
      mtl.preview = action.payload.preview;
      const updateMaterials = Object.assign({}, state.materials, {
        [action.payload._id]: mtl,
      });
      return { ...state, materials: updateMaterials };
    case SET_SEARCH_MATERIALS:
      return { ...state, searchedMaterials: action.payload };
    case DELETE_MATERIAL:
      const mtls = state.materials;
      delete mtls[action.payload];
      return { ...state, materials: mtls };
    case UPDATE_SEARCH_MATERIAL:
      const searchedMaterials = state.searchedMaterials;
      searchedMaterials[action.payload._id] = action.payload;
      return { ...state, searchedMaterials };
    case DELETE_SEARCH_MATERIAL:
      const search = state.searchedMaterials;
      delete search[action.payload];
      return { ...state, searchedMaterials: search };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};

export const addMaterial = material => ({
  type: ADD_MATERIAL,
  payload: material,
});

export const setSearchedMaterials = materials => ({
  type: SET_SEARCH_MATERIALS,
  payload: materials,
});

const updateSearchMaterial = model => ({
  type: UPDATE_SEARCH_MATERIAL,
  payload: model,
});

const deleteSearchMaterialFromState = id => ({
  type: DELETE_SEARCH_MATERIAL,
  payload: id,
});

export const getSearchedMaterials = state => state.materials.searchedMaterials;

const setMtlPreview = (_id, preview) => ({
  type: SET_MATERIAL_REVIEW,
  payload: { _id, preview },
});

const setMaterials = materials => ({ type: SET_MATERIALS, payload: materials });

const deleteMaterialFromState = id => ({ type: DELETE_MATERIAL, payload: id });

export const getMaterials = state => state.materials.materials;

export function createMaterial(data) {
  return async (dispatch, getState) => {
    const state = getState();
    const organization = getOrganization(state);
    data.organization = organization && organization.slug;
    const result = await fetch(`${conf.apiRoot}/api/materials`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    }).then(res => {
      if (res.status === 200) return res.json();
      return null;
    });
    if (result) {
      dispatch(addMaterial(result.model));
    }
  };
}

export function fetchMaterials(query = { page: 0 }, type) {
  return async (dispatch, getState) => {
    const state = getState();
    const results = getMaterials(state);
    const perPage = state.materials.perPage;
    if (
      Object.keys(results).length > (query.page || 1) * perPage &&
      !query.tags &&
      !query.limit &&
      !query.friendlyName
    )
      return results;
    const organization = getOrganization(state);
    query.organization = organization && organization.slug;
    const materials = await fetch(
      `${conf.apiRoot}/api/materials?${queryString.stringify(query)}`,
      {
        credentials: 'include',
      }
    ).then(res => {
      if (res.status === 200) return res.json();
      return [];
    });
    const formatedMaterials = materials.reduce((acc, el) => {
      acc[el._id] = el;
      return acc;
    }, {});
    if (type === 'search') {
      dispatch(setSearchedMaterials(formatedMaterials));
    } else {
      dispatch(setMaterials(formatedMaterials));
    }
    return formatedMaterials;
  };
}

export const getMaterial = id => async (dispatch, getState) => {
  const state = getState();
  const materials = getMaterials(state);
  if (materials[id]) return materials[id];
  const material = await fetch(`${conf.apiRoot}/api/materials/${id}`, {
    credentials: 'include',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (material) dispatch(addMaterial(material));
  return material;
};

export const saveMaterial = (id, update) => async dispatch => {
  const result = await fetch(`${conf.apiRoot}/api/materials/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(update),
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result && result.status === 'ok') {
    if (update.state === 'Discontinued') {
      dispatch(deleteMaterialFromState(id));
      dispatch(deleteSearchMaterialFromState(id))
    } else {
      dispatch(addMaterial(result.model));
      dispatch(updateSearchMaterial(result.model))
    }
  }
  return result.model;
};

export const saveMaterials = (ids, update) => async dispatch => {
  let result = { status: 'ok' };
  const data = await Promise.all(
    ids.map(id => dispatch(saveMaterial(id, update)))
  );
  return result;
};

export const getMaterialPreview = id => async dispatch => {
  const result = await fetch(`${conf.apiRoot}/api/materials/${id}/previews`, {
    credentials: 'include',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  console.log(result);
  if (result) dispatch(setMtlPreview(id, result));
  return result;
};

export const deleteMaterial = id => async dispatch => {
  const result = await fetch(`${conf.apiRoot}/api/materials/${id}`, {
    credentials: 'include',
    method: 'DELETE',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result && result.status === 'ok') {
    dispatch(deleteMaterialFromState(id));
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/modules/materials.js